var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2346 2.88135C16.4731 2.88135 16.7017 2.97601 16.8703 3.14456L19.9399 6.21415C20.2908 6.56525 20.2908 7.13441 19.9399 7.4855L10.7314 16.694C10.5827 16.8426 10.3865 16.9346 10.177 16.9536L6.80056 17.2606C6.53494 17.2846 6.27217 17.1895 6.08363 17.0008C5.89491 16.8122 5.7998 16.5495 5.82403 16.2839L6.13088 12.9074C6.14999 12.698 6.24179 12.5017 6.39048 12.353L15.5993 3.14456C15.7679 2.97601 15.9963 2.88135 16.2346 2.88135ZM14.7434 6.54281L16.5416 8.34104L18.033 6.84982L16.2346 5.05159L14.7434 6.54281ZM15.2703 9.6124L13.472 7.81417L7.89196 13.3943L7.71212 15.3723L9.69019 15.1925L15.2703 9.6124Z",
    fill: "#2E9EFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2703 9.6124L13.472 7.81417L7.89196 13.3943L7.71212 15.3723L9.69019 15.1925L15.2703 9.6124Z",
    fill: "#2E9EFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9103 20.8598H3.12305V19.062H13.9103V20.8598Z",
    fill: "#2E9EFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.c6c941616c804d7659217f25f0ccc885.svg";
export { ForwardRef as ReactComponent };